import React, { useEffect, useState } from 'react'
import GoldSiverHeader from '../HomePage/GoldSiverHeader'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import axiosInstance from '../../api/axios'
import { API_ENDPOINTS } from '../../api/endpoint'
import { getProfile } from '../../store/auth'
import { useDispatch } from 'react-redux'

function Works() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const user_data = useSelector(state => state.auth.user_data)
    const [missions, setMissions] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedMissions, setSelectedMissions] = useState([])

    useEffect(() => {
        fetchMissions()
        dispatch(getProfile())
    }, [dispatch])

    const fetchMissions = async () => {
        try {
            setLoading(true)
            const response = await axiosInstance.get(API_ENDPOINTS.GET_MISSIONS)
            if (response.data && response.data.success) {
                setMissions(response.data.missions || [])
            } else {
                toast.error(response.data?.error || t('Failed to load missions'))
            }
        } catch (error) {
            console.error('Error fetching missions:', error)
            toast.error(t('Failed to load missions'))
        } finally {
            setLoading(false)
        }
    }

    const handleMissionSelect = (missionId) => {
        setSelectedMissions(prev => {
            if (prev.includes(missionId)) {
                return prev.filter(id => id !== missionId)
            } else {
                return [...prev, missionId]
            }
        })
    }

    const handleClaimMission = async (missionId) => {
        try {
            const response = await axiosInstance.post(API_ENDPOINTS.CLAIM_MISSION, {
                mission_id: missionId
            })
            
            if (response.data && response.data.success) {
                toast.success(t('Mission reward claimed successfully!'))
                // Refresh missions and profile
                await fetchMissions()
                await dispatch(getProfile())
            } else {
                toast.error(response.data?.error || t('Failed to claim mission reward'))
            }
        } catch (error) {
            console.error('Error claiming mission:', error)
            toast.error(error?.response?.data?.error || t('Failed to claim mission reward'))
        }
    }

    const getDifficultyClass = (difficulty) => {
        switch (difficulty) {
            case 'easy':
                return 'normal'
            case 'normal':
                return 'easy'
            case 'hard':
                return 'hard'
            default:
                return 'normal'
        }
    }

    const getDifficultyLabel = (difficulty) => {
        switch (difficulty) {
            case 'easy':
                return t('Easy')
            case 'normal':
                return t('Normal')
            case 'hard':
                return t('Hard')
            default:
                return t('Normal')
        }
    }

    const getRewardImage = (rewardType) => {
        if (rewardType === 'silver') {
            return '/images/mock-05.png' // Silver coin image
        } else if (rewardType === 'gold') {
            return '/images/game-ui/p2.png' // Gold coin image
        }
        return '/images/work/gold.png'
    }

    return (
        <div>
            <GoldSiverHeader previous={'/home'} title={t('Works')}>
                <section className="ar_work_area_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ar_work_area_main">
                                    <div className="ar_work_area">
                                        {/* Header */}
                                        <div className="ar_single_item_table_work heading">
                                            <div className="ar_work_single_text text heading">
                                                <p>{t('Work')}</p>
                                            </div>
                                            <div className="ar_work_single_text gold heading">
                                                <p>{t('Reward')}</p>
                                            </div>
                                            <div className="ar_work_single_text heading">
                                                <p>{t('Info')}</p>
                                            </div>
                                            <div className="ar_work_single_text heading">
                                                <p>{t('Progress')}</p>
                                            </div>
                                            <div className="ar_work_single_text check heading">
                                                <p>{t('Select')}</p>
                                            </div>
                                        </div>
                                        
                                        {/* Missions List */}
                                        <div className="ar_workFlex_wrapper">
                                            {loading ? (
                                                <div className="text-center text-white p-4">
                                                    <p>{t('Loading missions...')}</p>
                                                </div>
                                            ) : missions.length === 0 ? (
                                                <div className="text-center text-white p-4">
                                                    <p>{t('No missions available today.')}</p>
                                                </div>
                                            ) : (
                                                missions.map((mission) => {
                                                    const difficultyClass = getDifficultyClass(mission.difficulty)
                                                    const isSelected = selectedMissions.includes(mission.id)
                                                    const isCompleted = mission.is_completed
                                                    const isClaimed = mission.is_claimed
                                                    
                                                    return (
                                                        <div 
                                                            key={mission.id} 
                                                            className={`ar_single_item_table_work ${difficultyClass}`}
                                                        >
                                                            <div className="ar_work_single_text text">
                                                                <p>
                                                                    <span>({getDifficultyLabel(mission.difficulty)})</span>
                                                                    {mission.mission_name}
                                                                </p>
                                                            </div>
                                                            <div className="ar_work_single_text gold">
                                                                <p>
                                                                    <img src={getRewardImage(mission.reward_type)} alt="" />
                                                                    {mission.reward_value}
                                                                </p>
                                                            </div>
                                                            <div className="ar_work_single_text">
                                                                <p>{mission.progress}/{mission.target_value}</p>
                                                            </div>
                                                            <div className="ar_work_single_text">
                                                                <p>{Math.round(mission.progress_percent)}%</p>
                                                            </div>
                                                            <div className="ar_work_single_text check">
                                                                {isClaimed ? (
                                                                    <img src="/images/work/check.png" alt="" style={{ opacity: 0.5 }} />
                                                                ) : isCompleted ? (
                                                                    <img 
                                                                        src="/images/work/check.png" 
                                                                        alt="" 
                                                                        onClick={() => handleClaimMission(mission.id)}
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                ) : (
                                                                    <div 
                                                                        onClick={() => handleMissionSelect(mission.id)}
                                                                        style={{ 
                                                                            cursor: 'pointer',
                                                                            width: '24px',
                                                                            height: '24px',
                                                                            border: isSelected ? '2px solid #4CAF50' : '2px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            backgroundColor: isSelected ? '#4CAF50' : 'transparent',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}
                                                                    >
                                                                        {isSelected && <span style={{ color: 'white', fontSize: '14px' }}>✓</span>}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )}
                                        </div>
                                        
                                        {/* Buttons */}
                                        <div className="ar_work_btn">
                                            {/* <div className="ar_work_single_btn">
                                                <img src="/images/work/input.png" alt=""/>
                                            </div> */}
                                            <div className="ar_work_single_btn">
                                                <a 
                                                    href="#" 
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        // Save selected missions (if needed in future)
                                                        if (selectedMissions.length > 0) {
                                                            toast.info(t('{{count}} missions selected', { count: selectedMissions.length }))
                                                        } else {
                                                            toast.warning(t('Please select at least one mission'))
                                                        }
                                                    }}
                                                >
                                                    <img src="/images/work/workbtn2.png" alt=""/>
                                                </a>
                                                <div className="ar_work_btn_xont">
                                                    <p>{t('Save')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </GoldSiverHeader>
        </div>
    )
}

export default Works
